import { gql } from 'react-apollo';

export default gql`
  mutation createWefunderInvestorUser(
    $input: CreateWefunderInvestorUserInput!
  ) {
    createWefunderInvestorUser(input: $input) {
      _id
      firstName
      lastName
      email
      offerId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/createWefunderInvestorUser.js